import React from "react"
import {Button, Table} from "react-bootstrap";

export default class NewPostsList extends React.Component {

    constructor(props) {
        super(props);
        const {posts} = props

        this.state = {
            posts: posts
        }
    }

    componentWillReceiveProps(nextProps) {
        const {posts} = nextProps
        this.setState({
            posts: posts
        });
    }

    render() {
        return <Table striped bordered hover size="sm">
            <thead>
            <tr>
                <th>Id</th>
                <th>Date</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            {this.state.posts.map((post, index) => {

                let creationDate =  new Date(post.creationDate)

                return <tr key={index}>
                    <td>{post.id}</td>
                    <td>{creationDate.toLocaleString("fr-FR")}</td>
                    <td>
                        <Button variant="outline-warning" type="submit" data-postid={post.id} onClick={this.props.clickOnPost}>
                            Edit
                        </Button>
                    </td>
                </tr>
            })}
            </tbody>
        </Table>
    }
}